export const theme = {
  colors: {
    // Hauptfarben
    primary: '#2ecc71',
    secondary: '#27ae60',
    accent: '#a3e635',
    
    // Text
    text: '#2c3e50',
    textLight: '#7f8c8d',
    textDark: '#1a252f',
    
    // Hintergründe
    background: '#ffffff',
    backgroundLight: '#f8f9fa',
    backgroundDark: '#2c3e50',
    
    // Status
    success: '#27ae60',
    warning: '#f39c12',
    error: '#e74c3c',
    info: '#3498db',
    
    // Graustufen
    white: '#ffffff',
    lightGray: '#ecf0f1',
    gray: '#95a5a6',
    darkGray: '#34495e',
    black: '#2c3e50',
    
    // Gradient Farben
    gradients: {
      hero: 'linear-gradient(135deg, rgba(34, 197, 94, 0.9) 0%, rgba(16, 185, 129, 0.9) 50%, rgba(5, 150, 105, 0.9) 100%)',
      primary: 'linear-gradient(45deg, #2ecc71, #27ae60)',
      secondary: 'linear-gradient(45deg, #a3e635, #22c55e)',
      success: 'linear-gradient(45deg, #27ae60, #2ecc71)',
      card: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
      ponyclub: 'linear-gradient(135deg, rgba(134, 239, 172, 0.9) 0%, rgba(34, 197, 94, 0.9) 50%, rgba(5, 150, 105, 0.9) 100%)',
      muki: 'linear-gradient(135deg, rgba(187, 247, 208, 0.9) 0%, rgba(167, 243, 208, 0.9) 50%, rgba(134, 239, 172, 0.9) 100%)'
    }
  },
  
  fonts: {
    primary: "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif",
    script: "'Dancing Script', cursive",
    
    sizes: {
      xs: '0.75rem',    // 12px
      sm: '0.875rem',   // 14px
      base: '1rem',     // 16px
      lg: '1.125rem',   // 18px
      xl: '1.25rem',    // 20px
      '2xl': '1.5rem',  // 24px
      '3xl': '1.875rem', // 30px
      '4xl': '2.25rem', // 36px
      '5xl': '3rem',    // 48px
      '6xl': '3.75rem', // 60px
      '7xl': '4.5rem',  // 72px
    },
    
    weights: {
      light: 300,
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700
    }
  },
  
  spacing: {
    xs: '0.25rem',   // 4px
    sm: '0.5rem',    // 8px
    md: '1rem',      // 16px
    lg: '1.5rem',    // 24px
    xl: '2rem',      // 32px
    '2xl': '3rem',   // 48px
    '3xl': '4rem',   // 64px
    '4xl': '5rem',   // 80px
    '5xl': '6rem',   // 96px
  },
  
  borderRadius: {
    sm: '0.25rem',   // 4px
    md: '0.5rem',    // 8px
    lg: '0.75rem',   // 12px
    xl: '1rem',      // 16px
    '2xl': '1.5rem', // 24px
    full: '9999px'
  },
  
  shadows: {
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    card: '0 15px 35px rgba(0, 0, 0, 0.1)',
    hover: '0 25px 50px rgba(0, 0, 0, 0.2)',
    glow: '0 0 20px rgba(46, 204, 113, 0.5)'
  },
  
  breakpoints: {
    xs: '0px',
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    '2xl': '1536px'
  },
  
  animations: {
    duration: {
      fast: '0.15s',
      normal: '0.3s',
      slow: '0.6s'
    },
    
    easing: {
      linear: 'linear',
      ease: 'ease',
      easeIn: 'ease-in',
      easeOut: 'ease-out',
      easeInOut: 'ease-in-out',
      bounce: 'cubic-bezier(0.68, -0.55, 0.265, 1.55)'
    }
  },
  
  zIndex: {
    dropdown: 1000,
    sticky: 1020,
    fixed: 1030,
    modal: 1040,
    popover: 1050,
    tooltip: 1060,
    notification: 1070
  }
};